import React from 'react'
import {
    PageTitleText 
 } from '../../../../widget/styledComponents/headings.style';
// import { ImportContactContainer } from './security.style';

import SecurityListTableContainer from './widgets/security_list_table'
import AddSecurityBtn from './widgets/add_security_btn';

function SecurityPageWidget() {

  return (
    <div className=''>
        <div className='row'>
            <div className='col s12 m3'>
                <PageTitleText>
                    
                </PageTitleText>
            </div>
            
        </div>  
        {/* 
        <div class="input-field col s12 m6">
            <label >Username</label><br/>
            <input type="text" ref={title} class="validate" required/>
        </div> 
        */}
        
        <AddSecurityBtn />

        {/* <ImportContactContainer/> */}
        
        <SecurityListTableContainer/>
       
    </div>
  )
}

export default SecurityPageWidget